import PhotoCarousel from './PhotoCarousel';

export default PhotoCarousel;
